import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'psf-supporter-actions-screener',
		path: '/p/:slug/psf/supporter-actions-screener',
		component: loadable(async () => import(/* webpackChunkName: "pages/psf-supporter-actions-screener" */ './index'), {
			exportName: 'PsfSupporterActionsScreener',
			fallback: Loading,
		}),
		frame: { header: true, footer: false },
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
